import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DescripcionPublicationComponent } from '../descripcion-publication/descripcion-publication.component';
import { IonicModule } from '@ionic/angular';

import { FormsModule } from '@angular/forms'; // Import FormsModule
import { PublicationModuleModule } from '../../publication-module/publication-module.module';
import { PreventDoubleActionDirective } from 'src/app/directives/prevent-double-action.directive';

@NgModule({
    declarations: [
        DescripcionPublicationComponent
    ],
    exports: [
        DescripcionPublicationComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        PublicationModuleModule,
        FormsModule, // Add FormsModule here
        PreventDoubleActionDirective
    ]
})
export class DescriptionModuleModule { }
